import React, {Component} from 'react';

class Stepper extends Component {
    constructor(props) {
        super(props);
        this.increase = this.increase.bind(this);
        this.decrease = this.decrease.bind(this);
        this.state = {
            step: 0
        }
    }

    increase(e) {
        e.preventDefault();
        if (this.state.step < 10) {
            let nextStep = this.state.step + 1;
            this.setState({step: nextStep});
            this.props.handleStepChange(nextStep)
        }
    }

    decrease(e) {
        e.preventDefault();
        if (this.state.step > 0) {
            let nextStep = this.state.step - 1;
            this.setState({step: nextStep});
            this.props.handleStepChange(nextStep)
        }
    }

    render() {
        let errorMessage = '';
        if (this.props.validField === 'empty') {
            errorMessage = <em id="email-error" class="state-error">Please select any services.</em>;
        }
        return (
            <label
                className={this.props.validField === 'empty' ? "field prepend-icon state-error" : "field state-success"}>
                <div className="stepper-wrap"
                     style={{'margin': '0px 34px 0px 0px'}}>
                    <input type="text"
                           value={this.state.step}
                           style={{'margin': '0px', 'ariaInvalid': 'false'}}
                           className="gui-input stepperblock"
                    />
                    <div className="stepper-btn-wrap">
                        <a
                            className="stepper-btn-up"
                            onClick={this.increase}
                        > </a>
                        <a
                            className="stepper-btn-dwn"
                            onClick={this.decrease}
                        > </a>
                    </div>
                </div>
                {
                    errorMessage
                }
            </label>
        )
    }
}

export default Stepper;


/** WEBPACK FOOTER **
 ** ./src/components/Stepper.js
 **/